        <!-- HJ212GeoMap HJ212实时地图 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="hJ212Records">
      <div class="hJ212Records_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>HJ212实时地图</h1>
      <div class="hJ212Records_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>
    <!-- map地图 -->
    <div class="hJ212GeoMap">
      <baidu-map id="allmap" @ready="handler" :center="center" :zoom="7">
        <bm-marker
          @click="infoWindowOpen(item)"
          v-for="(item, index) in map"
          :key="index"
          :icon="{
            url:
              item.warning == 0
                ? item.online == 1
                  ? require('../../assets/img/normal.png')
                  : require('../../assets/img/offline.png')
                : require('../../assets/img/police.png'),
            size: { width: 30, height: 30 },
          }"
          :position="item.center"
          animation="BMAP_ANIMATION_DROP"
          :title="
            item.warning == 0 ? (item.online == 1 ? '在线' : '离线') : '警报'
          "
        >
          <bm-label
            :content="item.name"
            :labelStyle="{
              color:
                item.warning == 0
                  ? item.online == 1
                    ? '#39C37B'
                    : '#333'
                  : '#F78B44',
              borderColor:
                item.warning == 0
                  ? item.online == 1
                    ? '#39C37B'
                    : '#333'
                  : '#F78B44',
              fontSize: '12px',
            }"
            :offset="{ height: 30 }"
          />
          <bm-info-window
            @close="infoWindowClose(item)"
            @open="infoWindowOpen(item)"
            :show="item.isHas"
          >
            <div class="hJ212GeoMap_box">
              <h1>采集点：{{ item.name }}</h1>
              <p>
                设备ID：{{ item.id }} / 在线状态：{{
                  item.online == 1 ? "在线" : "离线"
                }}
                / 警报状态：{{ item.warning == 0 ? "正常" : "警报" }}
              </p>
              <p>描述：{{ item.text }}</p>
            </div>
          </bm-info-window>
        </bm-marker>
      </baidu-map>
    </div>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",
      // 当前坐标位置
      center: {
        lng: "110.30764968",
        lat: "30.1200491",
      },
      map: [],
    };
  },
  created() {
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);

    
        let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }
    //   获取设备坐标信息
    this.HJ212GeoMap();
  },
  methods: {
    //   获取设备坐标
    HJ212GeoMap() {
      let loginToken = localStorage.getItem("loginToken");
      this.$axios({
        method: "post",
        url: this.api,
        data: {
          txcode: "HJ212GeoMap", //交易码
          option: "SHOW", //交易选项，不填则返回设备列表。
          loginToken,
        },
      })
        .then((res) => {
          if (res.data._STATUS == "0") {
            let sites = res.data.sites;
            let map = [];
            for (let i = 0; i < sites.length; i++) {
              let list = {
                isHas: false,
                center: {
                  lng: sites[i].location[0],
                  lat: sites[i].location[1],
                },
                name: sites[i].name,
                id: sites[i].id,
                text: sites[i].text,
                online: sites[i].online,
                warning: sites[i].warning,
              };
              map.push(list);
            }

            this.map = map;
            // console.log(map);
          } else {
            // 登录超时调用
            this.loginTimeout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 地图
    handler({ BMap, map }) {
      // console.log(map);
      // 鼠标缩放
      map.enableScrollWheelZoom(true);
    },
    // 打开弹窗
    infoWindowOpen(marker) {
      marker.isHas = true;
    },
    // 关闭弹窗
    infoWindowClose(marker) {
      marker.isHas = false;
    },
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.hJ212Records {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .hJ212Records_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .hJ212Records_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// map地图
.hJ212GeoMap {
  position: absolute;
  top: 50px;
  left: 0px;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}
#allmap {
  width: 100%;
  height: 100%;
}
.hJ212GeoMap_box {
  h1 {
    color: #333;
    font-weight: bold;
    font-size: 20px;
    line-height: 36px;
  }
  p {
    font-size: 18px;
    line-height: 30px;
  }
}
</style>